// extracted by mini-css-extract-plugin
module.exports = {"paginate":"paginate_paginate___4KGU","number":"paginate_number__ecG72","ref":"paginate_ref__9NfeM"};